import { ActionCreator } from "redux";

import {
	ActionType,
	SnackbarMessageUpdatedAction,
	SnackbarVariant,
	SnackbarClickPayload
} from "./type";

export const setSnackbarMessage: ActionCreator<SnackbarMessageUpdatedAction> = (
	message: string,
	variant: SnackbarVariant = "info",
	clickPayload?: SnackbarClickPayload<any>
) => ({
	type: ActionType.AppSnackbarMessageUpdated,
	payload: {
		message,
		variant,
		clickPayload
	}
});
